(function () {
  var PLAN_KEY = 'asparesModelSearchPlan';
  var MAX_CANDIDATES = 12;

  function normalizeModelSearchInput(value) {
    return String(value || '')
      .replace(/\s+[-–—]\s+/g, ' ')
      .replace(/\s+[-–—]/g, ' ')
      .replace(/[-–—]\s+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  function compactSeparators(value) {
    return String(value || '')
      .replace(/[(),.'"[\]]/g, ' ')
      .replace(/\s+[-–—]\s+/g, ' ')
      .replace(/[^a-z0-9]/gi, '');
  }

  function tokenizeForPhrases(value) {
    return normalizeModelSearchInput(
      String(value || '').replace(/[(),.'"[\]]/g, ' ')
    ).split(/\s+/).filter(Boolean);
  }

  function pushPhraseWindows(push, tokens, maxWindows) {
    if (tokens.length < 3) return;

    var windows = [];
    var maxLen = Math.min(4, tokens.length);
    var start = 0;

    while (start < tokens.length) {
      var len = maxLen;
      while (len >= 2) {
        if (start + len <= tokens.length) {
          windows.push(tokens.slice(start, start + len).join(' '));
        }
        len -= 1;
      }
      start += 1;
    }

    windows.sort(function (a, b) {
      return b.length - a.length;
    });

    var added = 0;
    var index = 0;
    while (index < windows.length && added < maxWindows) {
      push(windows[index]);
      added += 1;
      index += 1;
    }
  }

  window.buildModelSearchQueries = function buildModelSearchQueries(value) {
    var original = String(value || '').trim();
    if (!original) return [];

    var candidates = [];
    var seen = Object.create(null);

    function push(q) {
      if (!q || q.length < 2) return;
      if (candidates.length >= MAX_CANDIDATES) return;

      var key = q.toLowerCase();
      if (seen[key]) return;

      seen[key] = true;
      candidates.push(q);
    }

    var primary = normalizeModelSearchInput(original);
    if (!primary) return [];

    push(primary);

    var compact = compactSeparators(original);
    push(compact);

    if (/[()]/.test(original)) {
      var parenSpaced = normalizeModelSearchInput(original.replace(/[()]/g, ' '));
      push(parenSpaced);

      var parenParts = original.match(/\(([^)]+)\)/g);
      if (parenParts) {
        parenParts.forEach(function (part) {
          push(part.replace(/[()]/g, '').trim());
        });
      }
    }

    if (/\./.test(original)) {
      push(normalizeModelSearchInput(original.replace(/\./g, ' ')));
    }

    if (/-/.test(original)) {
      push(normalizeModelSearchInput(original.replace(/-/g, ' ')));
    }

    var phraseTokens = tokenizeForPhrases(original);
    pushPhraseWindows(push, phraseTokens, 5);

    var meaningfulTokens = phraseTokens.filter(function (token) {
      return token.length >= 2;
    });

    if (meaningfulTokens.length > 1) {
      push(meaningfulTokens.join(' '));
    }

    meaningfulTokens.sort(function (a, b) {
      return b.length - a.length;
    });

    meaningfulTokens.forEach(push);

    return candidates;
  };

  window.compactModelQuery = function compactModelQuery(value) {
    var queries = window.buildModelSearchQueries(value);
    return queries.length ? queries[0] : '';
  };

  window.prepareModelSearch = function prepareModelSearch(input, options) {
    options = options || {};

    var label = String(input || '').trim();
    var queries = window.buildModelSearchQueries(label);
    if (!queries.length) return null;

    var primary = queries[0];

    sessionStorage.setItem(PLAN_KEY, JSON.stringify({
      label: label,
      queries: queries,
      brandFilter: options.brandFilter || null,
      dropBrandFilterAfter: options.dropBrandFilterAfter !== false
    }));

    return {
      q: primary,
      q_label: label !== primary ? label : null
    };
  };

  window.getModelSearchPlan = function getModelSearchPlan() {
    try {
      return JSON.parse(sessionStorage.getItem(PLAN_KEY) || 'null');
    } catch (err) {
      return null;
    }
  };

  window.clearModelSearchPlan = function clearModelSearchPlan() {
    sessionStorage.removeItem(PLAN_KEY);
  };

  window.buildModelSearchQueryString = function buildModelSearchQueryString(params) {
    var parts = [];

    params.forEach(function (value, key) {
      var encodedKey = encodeURIComponent(key);
      var encodedValue = encodeURIComponent(value);

      if (key === 'q' || key === 'q_label') {
        encodedValue = encodedValue.replace(/%20/g, '+');
      }

      parts.push(encodedKey + '=' + encodedValue);
    });

    return parts.join('&');
  };
})();
